// The Hangul alphabet for the tap-to-hear board and its practice modes. Each
// entry is [jamo, romanization, sample syllable]. We speak the SYLLABLE (가,
// 아…) because Korean TTS voices a full syllable reliably, whereas a bare jamo
// (ㄱ) is often read as its name. Consonants use ㅏ (a); vowels use the silent ㅇ
// so you hear the vowel alone.
export const HANGUL = {
  consonants: [['ㄱ', 'g', '가'], ['ㄴ', 'n', '나'], ['ㄷ', 'd', '다'], ['ㄹ', 'r / l', '라'], ['ㅁ', 'm', '마'], ['ㅂ', 'b', '바'], ['ㅅ', 's', '사'], ['ㅇ', 'ng / –', '아'], ['ㅈ', 'j', '자'], ['ㅊ', 'ch', '차'], ['ㅋ', 'k', '카'], ['ㅌ', 't', '타'], ['ㅍ', 'p', '파'], ['ㅎ', 'h', '하']],
  doubles: [['ㄲ', 'gg', '까'], ['ㄸ', 'dd', '따'], ['ㅃ', 'bb', '빠'], ['ㅆ', 'ss', '싸'], ['ㅉ', 'jj', '짜']],
  vowels: [['ㅏ', 'a', '아'], ['ㅑ', 'ya', '야'], ['ㅓ', 'eo', '어'], ['ㅕ', 'yeo', '여'], ['ㅗ', 'o', '오'], ['ㅛ', 'yo', '요'], ['ㅜ', 'u', '우'], ['ㅠ', 'yu', '유'], ['ㅡ', 'eu', '으'], ['ㅣ', 'i', '이']],
  complexVowels: [['ㅐ', 'ae', '애'], ['ㅔ', 'e', '에'], ['ㅒ', 'yae', '얘'], ['ㅖ', 'ye', '예'], ['ㅘ', 'wa', '와'], ['ㅙ', 'wae', '왜'], ['ㅚ', 'oe', '외'], ['ㅝ', 'wo', '워'], ['ㅞ', 'we', '웨'], ['ㅟ', 'wi', '위'], ['ㅢ', 'ui', '의']],
}

export const HANGUL_GROUPS = [
  ['consonants', 'Consonants', '자음'],
  ['doubles', 'Double consonants', '쌍자음'],
  ['vowels', 'Vowels', '모음'],
  ['complexVowels', 'Complex vowels', '복합 모음'],
]
